// Services.jsx

import React, { useState, useEffect } from 'react';
import NavBar from './NavBar';
import { FaBars, FaTimes} from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import './Services.css';
import service_first from './assets/images/services-page-first-image.jpg';
import service_second from './assets/images/shutterstock_57462100-1.jpg';
import service_third from './assets/images/service_graph.png';
import service_fourth from './assets/images/services-page-last-image-with-white-frosting.png';
import logo from './assets/images/favicon1.webp';
import logo1 from './assets/images/0040C0.png';

const Services = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    document.title = "Services – Bay Capital Advisors";
    
    // Find and update the favicon
    let favicon = document.querySelector("link[rel~='icon']");
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }
    favicon.href = logo; // Use your logo as favicon
    
    return () => {
      // Reset title when component unmounts if needed
      document.title = "Bay Capital Advisors";
    };
  }, []);
  
    const toggleMobileMenu = () => {
      setIsMobileMenuOpen(!isMobileMenuOpen);
    };
  
    const closeMobileMenu = () => {
      setIsMobileMenuOpen(false);
    };
  return (
    
    <div className="services-page">
      <div className="mobile-menu-button" onClick={toggleMobileMenu}>
        {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
      </div>
      
      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="mobile-dropdown-overlay" onClick={closeMobileMenu}>
          <div className="mobile-dropdown" onClick={(e) => e.stopPropagation()}>
            <NavBar isMobile={true} closeMenu={closeMobileMenu} />
          </div>
        </div>
      )}
        <section class="hero1">
    
        <div class="blue-overlay"></div>
    
    <header class="header1">
    <NavBar isMobile={false} />
  </header>
      <header className="services-header">
      
        <h1>SERVICES</h1>
        <p>Receive A High Level of Personal Attention and Expertise</p>
      </header>

      </section>
      
      <section className="services-expertise">
        <h2>FOCUSED EXECUTION EXPERTISE WITH GLOBAL REACH</h2>
        <div className="expertise-content">
          
          <p>Bay Capital Advisors advises companies across a narrow spectrum of sectors and geographic markets, including technology, life sciences, healthcare, consumer products & fashion, food and beverage, e-commerce, business to business services, fintech, chemicals and industrials. Geographically, we have considerable expertise in China, India, and European transactions. We have dedicated teams focused on individual sectors and relationships in certain foreign markets.</p>
          <div className="image-wrapper">
            <img src={service_first} alt="Experience Image" />
        </div>
        </div>
      </section>

      <section className="services-expertise1">
        <h2>BRINGING TO CLIENTS DECADES OF TRANSACTIONAL, OPERATIONAL, STRATEGIC AND NEGOTIATING EXPERIENCE</h2>
        <div className="expertise-content1">
        <div className="image-wrapper1">
            <img src={service_second} alt="Experience Image" />
        </div>
          <p>Our backgrounds as industry executives and experienced investment bankers, our exclusive focus on advisory services to high growth companies in the early stage and middle markets and our passion for what we do enable us to create greater outcomes for our clients. </p>
          
        </div>
      </section>

      <section className="services-expertise2">
        <h2>DRIVING PREMIUM VALUE FOR FOUNDERS AND SHAREHOLDERS</h2>
        <img src={service_third} alt="Experience Image" className="service-third-image" />
      </section>
      
      
      

      <section className="advisor-services-section">
            <h2>OUR EXPERTISE ENCOMPASSES A RANGE OF ADVISORY SERVICES</h2>
            <div className="advisor-service-cards">
                <div className="advisor-card blue-card">Mergers & Acquisitions Advisory</div>
                <div className="advisor-card1 white-card">Debt Finance & Asset Based Lending</div>
                <div className="advisor-card blue-card">Joint Ventures and Strategic Alliances</div>
                <div className="advisor-card2 white-card">International Growth Expansion</div>
                <div className="advisor-card2 blue-card">Cross Border Transactions</div>
                <div className="advisor-card2 white-card">Strategic Private Placements</div>
                <div className="advisor-card blue-card">Fairness Opinions and Valuations</div>
                <div className="advisor-card white-card">Mergers and Acquisitions Tax Advisory</div>
                
                <div className="advisor-card blue-card">Management Buyouts, Recapitalizations, Divestitures</div>
            </div>
        </section>
        <section className="services-expertise2">
        <div className="expertise-content2">
          
          <p>Whether you're a buyer or a seller, your banking advisor’s understanding of your business is the most crucial element of success in this sensitive and highly confidential relationship. By partnering with Bay Capital Advisors, you will receive a level of personal attention and expertise unmatched by any other advisory firm, large or small.</p>
          <img src={service_fourth} alt="Experience Image" className="advisor-service-image" />
        </div>
      </section>
       {/* Footer Section */}
    <div className="footer-section">
        <nav>
          <a href="/CoreValues">Core Values</a>
          <a href="/Resources">Resources</a>
          <a href="/ContactUs">Contact Us</a>
        </nav>
        <div className="footer-logo">
        <Link to="/"> {/* Add this Link wrapper */}
          <img src={logo1} alt="Bay Capital Advisors Logo" className="logo" />
        </Link>
        </div>
        <nav>
          <a href="/PrivacyPolicy">Privacy Policy</a>
          <a href="/TermsOfService">Terms of Service</a>
        </nav>
      </div>

      
    </div>
  );
};

export default Services;
